import { render, staticRenderFns } from "./PlaceholderAvatar.vue?vue&type=template&id=751a058f&"
import script from "./PlaceholderAvatar.vue?vue&type=script&lang=js&"
export * from "./PlaceholderAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlaceholderAvatar.vue"
export default component.exports